import {
    dataURLtoFile,
    RaikoButtonPrimary,
    RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoMaterialOutlinedInput, RaikoSectionContainer,
    RaikoSimpleMultiLineInputOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useState} from "react";
import UploadPhoto from "../../component/UploadPhoto/UploadPhoto";
import {css} from "@emotion/css";
import {stringIsEmpty} from "../../util/VariableChecker";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {MagazineSliderService} from "../../serverService/magazineService/MagazineSliderService";
import UploadThumbnail from "../../component/uploadThumbnail/UploadThumbnail";

export default function SliderAddNewSlide({addNewSliderToTable}) {

    const [photoFile, setPhotoFile] = useState([])
    const [photoUrl, setPhotoUrl] = useState("");

    const [name, setName] = useState("");
    const [writer, setWriter] = useState("")
    const [link, setLink] = useState("")
    const [description, setDescription] = useState("")

    const loading = new LoadingHelper(useLoadingDispatcher())

    const service = new MagazineSliderService()

    function handleAddNewSlider() {
        if (checkFields()) {
            loading.show()
            service.createNewSlider(
                name,
                writer,
                link,
                description,
                photoFile
            ).then(response => {
                showSuccessMessage("اسلایدر جدید با موفقیت ساخته شد.")
                addNewSliderToTable(response)
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }


    function checkFields() {
        let state = false
        let message

        if (photoFile === null)
            message = "لطفا تصویر اسلایدر را وارد نمایید."
        else if (stringIsEmpty(name))
            message = "لطفا عنوان اسلایدر را وارد نمایید."
        else if (stringIsEmpty(writer))
            message = "لطفا نویسنده اسلایدر را وارد نمایید."
        else if (stringIsEmpty(link))
            message = "لطفا لینک مقصد را وارد نمایید."
        else if (stringIsEmpty(description))
            message = "لطفا توضیحات را وارد نمایید."
        else
            state = true

        if (message)
            showWarningMessage(message)

        return state
    }

    const handleSelectImage = (imgSrc, fileName) => {
        const imageFile = dataURLtoFile(imgSrc, fileName)
        setPhotoUrl(imgSrc)
        setPhotoFile(imageFile)
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoSectionContainer
                title={"تصویر شاخص"}
            >
                <UploadThumbnail
                    avatarFile={photoUrl}
                    updateAvatar={handleSelectImage}
                    loading={false}
                    aspectRatio={12 / 5}
                />
            </RaikoSectionContainer>
            <RaikoGridTwoColumn>
                <RaikoMaterialOutlinedInput
                    labelText={"عنوان"}
                    value={name}
                    setValue={setName}
                />
                <RaikoMaterialOutlinedInput
                    labelText={"نویسنده"}
                    value={writer}
                    setValue={setWriter}
                />
            </RaikoGridTwoColumn>
            <RaikoMaterialOutlinedInput
                labelText={"لینک مقصد"}
                value={link}
                setValue={setLink}
            />
            <RaikoSimpleMultiLineInputOutlined
                labelText={"توضیحات"}
                value={description}
                setValue={setDescription}
            />
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary label={"افزودن"} onClick={handleAddNewSlider}/>
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}
